import { render, staticRenderFns } from "./ReportIcon.vue?vue&type=template&id=1885824e&scoped=true&"
import script from "./ReportIcon.vue?vue&type=script&lang=js&"
export * from "./ReportIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReportIcon.vue?vue&type=style&index=0&id=1885824e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885824e",
  null
  
)

export default component.exports